import React from 'react';

import CPSellerWinterList  from 'components/Tvendo/Sale/QuotaBPartner/Winter/QuotaSeller/List.js';

export default function () {
  return <CPSellerWinterList  />;
}